module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hant/3/1-4c5efe7a2fbcf37bd5bfb6c8d44d82fb.jpg";